// Extended classification table — Part 1: base categories + new ones
// Each entry: code_sh_10, description, taux_DD, taux_TVA, daps, daps_taux, fap[], mots_cles[]

const T = (code_sh_10, description, taux_DD, taux_TVA, daps_taux, fap, mots_cles) => ({
  code_sh_10, description, taux_DD, taux_TVA, daps: daps_taux > 0, daps_taux, fap, mots_cles,
  codes_sh: [code_sh_10.substring(0,5)],
});

export const CLASSIFICATION_TABLE = {
  // ═══ MATIÈRES PREMIÈRES ═══
  acier_brut: T('7208.51.00.00','Acier en lingots, billettes, tôles, bobines',5,19,0,[],
    ['acier','acier brut','tôle','bobine acier','billette','fer','acier inoxydable','inox']),
  aluminium_brut: T('7601.10.00.00','Aluminium sous formes brutes, barres, fils',5,19,0,[],
    ['aluminium','aluminium brut','barreau aluminium','profilé aluminium','alu']),
  cuivre_brut: T('7408.11.00.00','Cuivre brut, barres, fils de cuivre',5,19,0,[],
    ['cuivre','fil de cuivre','barre cuivre','câble cuivre nu']),
  plastiques_granules: T('3901.10.00.00','Matières plastiques en granulés, formes primaires',5,19,0,[],
    ['granulés plastique','PVC','polyéthylène','polypropylène','matière plastique brute','résine','plastique brut','granulé']),
  caoutchouc_brut: T('4001.10.00.00','Caoutchouc naturel et synthétique brut',5,19,0,[],
    ['caoutchouc','gomme','élastomère brut','latex']),
  produits_chimiques_base: T('2901.10.00.00','Produits chimiques inorganiques et organiques de base',5,19,0,[],
    ['acide','base chimique','produit chimique','solvant','réactif','soude','chlore']),
  bois_brut: T('4403.11.00.00','Bois brut, grumes, bois de sciage',5,19,0,[],
    ['bois','bois brut','grume','planche','madrier','bois de sciage','chêne','pin','sapin']),
  papier_carton: T('4802.55.00.00','Papier et carton',15,19,0,['C.C'],
    ['papier','carton','papier kraft','papier impression','ramette','papier A4','carton ondulé']),
  coton_brut: T('5201.00.00.00','Coton brut, non cardé ni peigné',0,19,0,[],
    ['coton brut','coton','fibre coton','coton non cardé']),
  zinc: T('7901.11.00.00','Zinc brut, non allié',5,19,0,[],
    ['zinc','zinc brut','tôle zinc','galvanisation']),
  plomb: T('7801.10.00.00','Plomb brut',5,19,0,[],
    ['plomb','plomb brut','lingot plomb']),

  // ═══ ÉQUIPEMENTS ET MACHINES ═══
  machines_industrielles: T('8458.11.00.00','Machines-outils, centres d\'usinage, tours, fraiseuses',5,19,0,[],
    ['machine outil','tour','fraiseuse','centre usinage','CNC','rectifieuse','machine industrielle']),
  pompes_compresseurs: T('8413.70.00.00','Pompes, compresseurs, ventilateurs',15,19,0,[],
    ['pompe','compresseur','ventilateur','turbine','soufflante','pompe hydraulique']),
  generateurs_moteurs: T('8501.10.00.00','Moteurs électriques, générateurs',15,19,0,['H.I.E.T'],
    ['moteur électrique','générateur','alternateur','dynamo','groupe électrogène']),
  transformateurs_electriques: T('8504.40.00.00','Transformateurs, convertisseurs, inductances',15,19,0,[],
    ['transformateur','onduleur','convertisseur','variateur','stabilisateur']),
  equipements_mesure: T('9026.10.00.00','Instruments de mesure industriels',15,19,0,['V.I.M'],
    ['débitmètre','manomètre','thermomètre industriel','capteur','analyseur','instrument mesure']),
  materiel_informatique: T('8471.30.00.00','Ordinateurs, serveurs, périphériques',0,19,0,['H.I.E.T'],
    ['ordinateur','serveur','laptop','écran','imprimante','PC','portable','moniteur','clavier','souris']),
  smartphones_tablettes: T('8517.12.00.00','Téléphones mobiles, smartphones, tablettes',30,19,30,['H.I.E.T'],
    ['téléphone','smartphone','mobile','tablette','iphone','samsung','galaxy','ipad']),
  climatisation: T('8415.10.00.00','Climatiseurs, splits',30,19,50,['C.C'],
    ['climatiseur','split','climatisation','clim','pompe à chaleur']),
  chaudieres: T('8402.19.00.00','Chaudières à vapeur, chaudières',15,19,0,[],
    ['chaudière','chaudière vapeur','chaudière gaz','chauffe-eau industriel']),
  tracteurs: T('8701.91.00.00','Tracteurs agricoles',5,19,0,[],
    ['tracteur','tracteur agricole','engin agricole']),
  vehicules: T('8703.23.00.00','Véhicules automobiles',30,19,50,[],
    ['voiture','véhicule','automobile','camion','fourgon','utilitaire','bus','minibus']),
  panneaux_solaires: T('8541.40.00.00','Panneaux solaires photovoltaïques',0,19,0,[],
    ['panneau solaire','photovoltaïque','solaire','module solaire','cellule solaire']),

  // ═══ PIÈCES ET COMPOSANTS ═══
  pieces_rechange_auto: T('8708.99.00.00','Pièces et accessoires de véhicules',15,19,30,[],
    ['pièce auto','pare-choc','filtre','frein','embrayage','pièce détachée','amortisseur','radiateur auto']),
  roulements_paliers: T('8482.10.00.00','Roulements à billes, à rouleaux, paliers',15,19,0,[],
    ['roulement','palier','SKF','FAG','NSK','bille','galet']),
  joints_garnitures: T('8484.10.00.00','Joints d\'étanchéité, garnitures',15,19,0,[],
    ['joint','garniture','joint torique','joint mécanique','étanchéité']),
  composants_electroniques: T('8542.31.00.00','Condensateurs, résistances, circuits, semi-conducteurs',0,19,0,[],
    ['condensateur','résistance','transistor','circuit intégré','PCB','composant électronique','semi-conducteur','microprocesseur','puce']),
  cables_electriques: T('8544.49.90.00','Fils et câbles électriques isolés',15,19,0,[],
    ['câble électrique','fil électrique','câble','conducteur','câble armé','câble isolé']),
  pneus: T('4011.10.00.00','Pneumatiques neufs',30,19,30,['C.C'],
    ['pneu','pneumatique','pneu voiture','pneu camion','pneu tracteur']),
  batteries: T('8507.60.00.00','Accumulateurs, batteries',15,19,0,[],
    ['batterie','accumulateur','batterie lithium','batterie voiture','pile']),
  robinetterie: T('8481.80.00.00','Robinetterie, vannes, soupapes',15,19,0,[],
    ['robinet','vanne','soupape','robinetterie','valve']),

  // ═══ CONSTRUCTION ═══
  ciment_platre: T('2523.29.00.00','Ciment Portland, plâtre',30,19,60,[],
    ['ciment','ciment Portland','plâtre','béton']),
  carrelage_ceramique: T('6907.21.00.00','Carreaux de céramique, faïence',30,19,60,[],
    ['carrelage','faïence','céramique','dalle','grès','carreau']),
  tubes_tuyaux_acier: T('7304.31.00.00','Tubes et tuyaux en acier',15,19,0,[],
    ['tube acier','tuyau acier','tube sans soudure','profilé creux','tuyauterie']),
  peintures_vernis: T('3209.10.00.00','Peintures, vernis, laques',30,19,30,[],
    ['peinture','vernis','laque','primaire','enduit']),
  verre_plat: T('7005.29.00.00','Verre plat, vitrage',30,19,30,['C.C'],
    ['verre','vitrage','verre plat','verre trempé','pare-brise','vitre']),
  bois_contreplaque: T('4412.31.00.00','Contreplaqué, panneaux de bois',30,19,0,['C.C'],
    ['contreplaqué','panneau bois','MDF','aggloméré','OSB','mélaminé']),
  sanitaire: T('6910.10.00.00','Appareils sanitaires en céramique',30,19,30,['C.C'],
    ['lavabo','WC','toilette','sanitaire','baignoire','bidet','évier']),
  quincaillerie: T('8302.41.00.00','Quincaillerie, serrures, ferrures',30,19,0,['C.C'],
    ['serrure','charnière','poignée','quincaillerie','ferrure','verrou','cadenas']),

  // ═══ ALIMENTAIRE ═══
  ble_cereales: T('1001.99.00.00','Blé, orge, maïs, sorgho',5,9,0,['V.P.H','C.C'],
    ['blé','orge','maïs','céréales','sorgho','semoule','farine']),
  sucre: T('1701.99.00.00','Sucre de canne ou de betterave',5,9,0,['C.C','I.S'],
    ['sucre','sucre brut','sucre raffiné','sucre blanc']),
  huiles_vegetales: T('1512.11.00.00','Huiles de soja, arachide, olive, tournesol',5,9,0,['C.C','I.S'],
    ['huile végétale','huile soja','huile tournesol','huile olive','huile palme','huile']),
  viandes: T('0202.30.00.00','Viandes fraîches, réfrigérées ou congelées',0,0,0,['I.S.V','D.S.V'],
    ['viande','bœuf','agneau','poulet','dinde','viande congelée','viande fraîche','mouton']),
  lait_produits_laitiers: T('0402.21.00.00','Lait, crème, beurre, fromage',0,9,0,['C.C','I.S'],
    ['lait','crème','beurre','fromage','yaourt','lait en poudre','produit laitier']),
  cafe_the: T('0901.21.00.00','Café, thé',5,9,0,['C.C','I.S'],
    ['café','thé','café moulu','café grain','café soluble','thé vert','thé noir']),
  chocolat_confiserie: T('1806.31.00.00','Chocolat, confiseries, cacao',30,19,0,['C.C','I.S'],
    ['chocolat','cacao','confiserie','bonbon','biscuit','gâteau','pâtisserie','praline','tablette chocolat']),
  poissons: T('0303.39.00.00','Poissons congelés',5,9,0,['I.S.V','C.C'],
    ['poisson','poisson congelé','sardine','thon','crevette','fruits de mer','saumon']),
  fruits_legumes: T('0805.10.00.00','Fruits et légumes frais',30,9,0,['V.P.H','C.C'],
    ['fruit','légume','orange','pomme','banane','tomate','pomme de terre','oignon','ail']),
  epices: T('0904.11.00.00','Épices',15,9,0,['C.C','I.S'],
    ['épice','poivre','curcuma','cannelle','gingembre','safran','cumin','paprika']),
  conserves: T('2005.99.00.00','Conserves alimentaires',30,19,0,['C.C','I.S'],
    ['conserve','tomate concentrée','concentré','harissa','confiture','olive','cornichon']),
  boissons: T('2202.10.00.00','Boissons non alcoolisées, jus',30,19,30,['C.C','I.S'],
    ['jus','boisson','soda','eau minérale','jus de fruit','limonade']),
  pates_alimentaires: T('1902.19.00.00','Pâtes alimentaires, couscous',30,19,0,['C.C','I.S'],
    ['pâtes','spaghetti','couscous','macaroni','nouilles','vermicelle']),
  riz: T('1006.30.00.00','Riz',5,9,0,['C.C','I.S'],
    ['riz','riz basmati','riz long','riz rond']),
  legumineuses: T('0713.31.00.00','Légumineuses sèches',5,9,0,['V.P.H','C.C'],
    ['lentille','pois chiche','haricot sec','fève','légumineuse']),

  // ═══ PHARMACEUTIQUE ═══
  produits_pharmaceutiques: T('3004.90.00.00','Médicaments, produits pharmaceutiques',0,0,0,['V.T.I'],
    ['médicament','produit pharmaceutique','antibiotique','vaccin','sérum','pharmacie','comprimé','sirop','gélule']),
  dispositifs_medicaux: T('9018.90.00.00','Dispositifs médicaux, instruments chirurgicaux',0,19,0,['V.T.I'],
    ['dispositif médical','seringue','cathéter','prothèse','instrument chirurgical','stéthoscope','appareil médical']),

  // ═══ CONSOMMATION ═══
  textiles_tissus: T('5208.11.00.00','Tissus de coton, synthétiques',30,19,40,['C.C'],
    ['tissu','coton','textile','drap','toile','jersey','étoffe','tissu ameublement']),
  vetements_confectionnes: T('6201.11.00.00','Vêtements confectionnés',30,19,60,['C.C'],
    ['vêtement','chemise','pantalon','robe','veste','costume','habit','prêt-à-porter','t-shirt','jeans']),
  chaussures: T('6403.99.00.00','Chaussures',30,19,50,['C.C'],
    ['chaussure','soulier','botte','sandale','basket','chaussure sport','mocassin']),
  electromenager: T('8450.11.00.00','Électroménager',30,19,50,['C.C'],
    ['lave-linge','réfrigérateur','congélateur','cuisinière','four','électroménager','machine à laver','micro-ondes','lave-vaisselle','aspirateur']),
  cosmetiques: T('3304.99.00.00','Parfums, produits de beauté, cosmétiques',30,19,100,['C.C'],
    ['parfum','crème beauté','cosmétique','maquillage','shampoing','déodorant','rouge à lèvres','fond de teint']),
  jouets: T('9503.00.00.00','Jouets, jeux, articles de sport',30,19,0,['C.C'],
    ['jouet','jeu','poupée','peluche','jeu vidéo','ballon','vélo enfant']),
  meubles: T('9403.60.00.00','Meubles',30,19,30,['C.C'],
    ['meuble','armoire','table','chaise','bureau','lit','canapé','étagère','commode','bibliothèque']),
  luminaires: T('9405.10.00.00','Luminaires, appareils d\'éclairage',30,19,0,['C.C'],
    ['lampe','luminaire','éclairage','lustre','plafonnier','spot','LED','ampoule','néon']),
  articles_menagers: T('7323.93.00.00','Articles ménagers en acier/inox',30,19,0,['C.C'],
    ['casserole','poêle','marmite','ustensile cuisine','couvert','assiette','verre','tasse']),
  detergents: T('3402.20.00.00','Détergents, produits d\'entretien',30,19,30,['C.C'],
    ['détergent','lessive','produit nettoyage','javel','savon','liquide vaisselle','désinfectant']),
  couches_hygiene: T('9619.00.00.00','Couches, serviettes hygiéniques',15,19,0,['C.C'],
    ['couche','couche bébé','serviette hygiénique','lingette','mouchoir','papier toilette']),
  lunettes: T('9004.10.00.00','Lunettes de soleil, montures',30,19,0,['C.C'],
    ['lunettes','lunettes soleil','monture','optique']),
  montres: T('9101.11.00.00','Montres',30,19,30,['C.C'],
    ['montre','horloge','montre bracelet','pendule']),
  bijoux: T('7113.19.00.00','Bijoux, joaillerie',30,19,0,['C.C'],
    ['bijou','bague','collier','bracelet','boucle oreille','joaillerie','or','argent bijou']),
  sacs_bagages: T('4202.11.00.00','Sacs, valises, bagages',30,19,30,['C.C'],
    ['sac','valise','bagage','sac à main','sac à dos','cartable','mallette']),

  // ═══ AGRO / PHYTO ═══
  pesticides_phyto: T('3808.91.00.00','Insecticides, herbicides, fongicides',5,9,0,['A.T.I'],
    ['pesticide','herbicide','insecticide','fongicide','produit phytosanitaire']),
  engrais: T('3105.20.00.00','Engrais azotés, phosphatés, potassiques',5,9,0,['V.P.H','A.T.I'],
    ['engrais','urée','DAP','NPK','ammonitrate','sulfate ammonium','fertilisant']),
  semences: T('1209.91.00.00','Semences, graines à semer',5,9,0,['V.P.H'],
    ['semence','graine','semence maraîchère','semence céréale','plants']),
  aliments_animaux: T('2309.90.00.00','Aliments pour animaux',5,9,0,['C.C','I.S'],
    ['aliment animal','fourrage','tourteau','soja tourteau','aliment bétail','aliment volaille']),

  // ═══ TÉLÉCOM / RADIO ═══
  equipements_radio_telecom: T('8525.60.00.00','Équipements de radiodiffusion, télécom',15,19,0,['H.I.E.T'],
    ['antenne','émetteur','récepteur radio','station radio','walkie-talkie','radio','routeur','modem','switch réseau']),

  // ═══ EMBALLAGE ═══
  emballages_plastique: T('3923.10.00.00','Emballages en plastique',15,19,0,['C.C'],
    ['emballage','film plastique','sachet','sac plastique','bouteille plastique','bidon','jerrycan']),
  emballages_verre: T('7010.90.00.00','Bouteilles, bocaux en verre',15,19,0,['C.C'],
    ['bouteille verre','bocal','flacon verre','pot verre']),

  // ═══ TEXTILE TECHNIQUE ═══
  fils_textiles: T('5509.11.00.00','Fils de fibres synthétiques',15,19,0,[],
    ['fil textile','fil polyester','fil nylon','fil acrylique','bobine fil']),
  cuir: T('4107.11.00.00','Cuir et peaux',15,19,0,[],
    ['cuir','peau','cuir bovin','cuir tanné','simili cuir']),
};

export const FAP_TABLE = {
  'C.C': {
    nom_complet: 'Contrôle de Conformité', organisme: 'Inspection aux frontières — Ministère du Commerce',
    description: 'Vérification de la conformité du produit aux normes algériennes', delai: '2 à 5 jours ouvrables',
    documents: ['Fiche technique du produit (FR ou AR)','Certificat de conformité du pays d\'origine','Étiquetage en arabe','GTIN enregistré GS1 Algeria (produits préemballés)']
  },
  'H.I.E.T': {
    nom_complet: 'Homologation Équipements Terminaux — ARPCE', organisme: 'ARPCE',
    description: 'Homologation obligatoire avant importation (Loi n°18-04)', delai: '30 à 60 jours',
    documents: ['Dossier technique du produit','Certificats de conformité CE ou équivalent','Rapport de tests laboratoire accrédité']
  },
  'V.P.H': {
    nom_complet: 'Visa Phytosanitaire', organisme: 'INPV',
    description: 'Contrôle phytosanitaire à l\'entrée sur le territoire', delai: '3 à 7 jours',
    documents: ['Certificat phytosanitaire du pays d\'origine','Liste des traitements appliqués']
  },
  'I.S.V': {
    nom_complet: 'Inspection Sanitaire Vétérinaire', organisme: 'Ministère de l\'Agriculture — Services vétérinaires',
    description: 'Contrôle sanitaire vétérinaire obligatoire', delai: '2 à 5 jours',
    documents: ['Certificat sanitaire vétérinaire','Certificat d\'origine de l\'animal']
  },
  'D.S.V': {
    nom_complet: 'Dérogation Sanitaire Vétérinaire', organisme: 'Ministère de l\'Agriculture',
    description: 'Pour produits animaux spécifiques', delai: 'Variable', documents: []
  },
  'V.T.I': {
    nom_complet: 'Visa Technique à l\'Importation', organisme: 'ANPP — Ministère de la Santé',
    description: 'Autorisation préalable obligatoire pour médicaments', delai: '30 à 90 jours',
    documents: ['Enregistrement du médicament en Algérie','Autorisation d\'importation de lot','Certificat d\'analyse du lot','Certificat BPF']
  },
  'V.I.M': {
    nom_complet: 'Visa Instruments de Mesure', organisme: 'ALGERAC',
    description: 'Vérification métrologique des instruments de mesure', delai: 'Variable',
    documents: ['Dossier technique métrologique']
  },
  'A.T.I': {
    nom_complet: 'Autorisation Technique à l\'Importation — Végétaux', organisme: 'INPV',
    description: 'Autorisation pour pesticides et produits phytosanitaires', delai: 'Variable',
    documents: ['Dossier d\'homologation du produit']
  },
  'I.S': {
    nom_complet: 'Inspection Sanitaire', organisme: 'Ministère du Commerce — Direction des fraudes',
    description: 'Contrôle sanitaire produits alimentaires', delai: '2 à 5 jours',
    documents: ['Certificat sanitaire','Fiche technique alimentaire']
  },
};

export const AVERTISSEMENTS = {
  general: 'Ces informations sont fournies à titre indicatif uniquement. Elles sont basées sur la réglementation en vigueur à la date indiquée. La réglementation algérienne du commerce extérieur évolue fréquemment par circulaires et notes ministérielles.',
  code_sh: 'Le code SH suggéré est basé sur la description fournie. Le classement tarifaire définitif est de la compétence exclusive des Douanes algériennes. En cas de doute, consultez votre transitaire agréé.',
  calcul_droits: 'Les montants calculés sont des estimations. Le montant définitif est liquidé par les services douaniers lors du dédouanement.',
  accord_ue: 'Note 2025-2026 : Des tensions existent entre l\'Algérie et l\'UE concernant l\'application de l\'accord d\'association. Vérifiez auprès de votre transitaire que le taux préférentiel EUR.1 est bien accepté.',
};
